import { useEffect } from "react";

// Sets document.title, the <meta name="description"> tag, and the canonical
// link for the current page, then restores the previous values on unmount.
// No react-helmet: this app has no per-route head mechanism yet, and one hook
// is all two pages need.
//
// The canonical matters most: index.html ships a hardcoded canonical pointing
// at the homepage, so without this every route tells Google "the real page is
// /", and these pages get consolidated away instead of indexed.
export default function usePageMeta(title, description) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    let meta = document.querySelector('meta[name="description"]');
    const prevDescription = meta?.getAttribute("content") ?? null;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description);

    let canonical = document.querySelector('link[rel="canonical"]');
    const prevCanonical = canonical?.getAttribute("href") ?? null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", window.location.origin + window.location.pathname);

    return () => {
      document.title = prevTitle;
      if (prevDescription != null) meta.setAttribute("content", prevDescription);
      if (prevCanonical != null) canonical.setAttribute("href", prevCanonical);
    };
  }, [title, description]);
}
